import { Col, Form, Input, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utils/api/fetchApi';

//布局
const layout = {
    // labelCol: { span: 4 },
    // wrapperCol: { span: 4 },
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const { sendPageData } = data;
    const ref = useRef<any>(undefined);
    const [cateringServiceTypeData, setCateringServiceTypeData] = useState<any>();
    const [branchStoreData, setBranchStoreData] = useState<any>();
    const [wsListenerTypeData, setWsListenerTypeData] = useState<any>();
    const [userData, setUserData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = '';

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'showLists',
                apiVariable: 'cateringServiceType@wsListenerType'
            }).then(res => {
                if (res.success) {
                    const { cateringServiceType, wsListenerType } = res.data;
                    console.log(res.data);
                    
                    setCateringServiceTypeData(cateringServiceType);
                    setWsListenerTypeData(wsListenerType);
                }
            })
            fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setBranchStoreData(res.data);
                }
            })
            fetchApi.GET(wmService, {
                apiId: "user",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setUserData(res.data);
                }
            })
        }
        fetchData();
        if (data.type === 'NEW') {
            form.setFieldValue('branchStoreId', sendPageData?.branchStoreId);
        }
    }, []);

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'branchStoreUser',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '服务'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                width={800}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item
                                label="服务类型"
                                name="cateringServiceTypeId"
                                rules={[{ required: true, message: '餐饮服务类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="选择服务类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(cateringServiceTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item
                                label="分店"
                                name="branchStoreId">
                                <Select
                                    showSearch
                                    placeholder="选择分店"
                                    optionFilterProp="children"
                                    disabled={true}
                                    // defaultValue={sendPageData?.branchStoreId}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(branchStoreData, { itemName: 'branchStoreName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item
                                label="用户"
                                name="userId"
                                rules={[{ required: true, message: '用户!' }]}>
                                <Select
                                    showSearch
                                    placeholder="选择用户"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(userData, { itemName: 'userName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item
                                label="websocket监听类型"
                                name="wsListenerTypeId"
                                rules={[{ required: true, message: 'websocket监听类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="选择websocket监听类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wsListenerTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;